import { DATE_VALUES } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'
import { QUICK_FILTERS_CHANGE } from 'containers/ResolutionCenter/QuickFilters/constants'

import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_DETECTED_BY_FILTER,
  SORTING_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    data: {
      results: [],
    },
    page: 1,
    search: '',
    loader: false,
    error: null,
    generalFilter: 0,
    detectedByFilter: null,
    // Redesign time frame (legacy omits feDateRange so this default is unused there).
    dateFilter: DATE_VALUES.DAYS_BACK_90,
    // null = "no explicit sort" -> the epic omits sortingBy and the endpoint
    // keeps its default -created order.
    sortingBy: null,
    sortingDirection: 'desc',
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case QUICK_FILTERS_CHANGE:
      case COMPANY_FILTER_CHANGE:
        return { ...state, page: 1, loader: true }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case GENERAL_FILTER_CHANGE:
        return {
          ...state,
          generalFilter: action.payload.value,
          page: 1,
          loader: true,
          message: null,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          data: {
            results: [],
          },
        }
      case DATA_REQUEST_ASYNC.CANCEL:
        // Fires on tab switch — IC-49333 resets sort along with the page.
        return {
          ...state,
          loader: false,
          page: 1,
          sortingBy: null,
          sortingDirection: 'desc',
        }
      case SET_DETECTED_BY_FILTER:
        return {
          ...state,
          detectedByFilter: action.payload.values,
        }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.value,
          page: 1,
          loader: true,
        }
      case SORTING_CHANGE:
        return {
          ...state,
          sortingBy: action.payload.sortingBy,
          sortingDirection: action.payload.sortingDirection,
          page: 1,
          loader: true,
        }
      default:
        return state
    }
  }
}
